import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {withRouter} from "react-router-dom";
import {useCurrentState} from "../globalState";
import {apiGet, apiSetAccessToken} from "../api";

const styles = {
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
};

const LinkButton = (props) => {
    const {
        history,
        location,
        match,
        staticContext,
        to,
        onClick,
        ...rest
    } = props;
    return (
        <Button
            {...rest} // `children` is just another prop!
            onClick={(event) => {
                onClick && onClick(event);
                history.push(to);
            }}
        />
    )
};

LinkButton.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

let LinkButtoned = withRouter(LinkButton);

function ButtonAppBar(props) {
    const {classes} = props;
    let [user, setUser] = useCurrentState("user");
    let [title, _] = useCurrentState("title");
    let [toolbar, setToolbar] = useCurrentState("toolbar");
    useEffect(() => {
        let tok = window.localStorage.getItem("user_access_token");
        apiSetAccessToken(tok);
        apiGet("user/0").then((res) => {
            setUser(res.data.user);
        });
    }, [classes.root]);


    let loggedIn = <LinkButtoned to={"/login"}>Login</LinkButtoned>;

    if (user.id) {
        loggedIn = <React.Fragment>
            <LinkButtoned color={"inherit"} to={"/user"}>Hello, {user.name}</LinkButtoned>
            <LinkButtoned color={"inherit"} to={"/requests"}>Requests</LinkButtoned>
            <LinkButtoned color={"inherit"} to={"/identities"}>Identities</LinkButtoned>
            <LinkButtoned color={"inherit"} to={"/access_tokens"}>Access tokens</LinkButtoned>
            {user.id === 1 && <LinkButtoned color={"inherit"} to={"/admin"}>Admin</LinkButtoned>}
            <LinkButtoned color={"inherit"} to={"/logout"}>Logout</LinkButtoned>
        </React.Fragment>;
    }

    return (
        <div className={classes.root}>
            {toolbar ?
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit" className={classes.grow}>
                            {title}
                        </Typography>
                        {loggedIn}
                    </Toolbar>
                </AppBar> : null}
        </div>
    );
}

ButtonAppBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ButtonAppBar);